import { useMemo } from "react";
import { useAppSelector } from "store";
import { selectSelectedCountryId } from "store/country/countrySlice";
import { useGetAllowOnlinePaymentQuery, useGetCurrentDiscountQuery } from "store/organisation-country/organisation-country-API";

export const useGetOnlinePaymentDiscountQuery = (countryId?: number) => {
  const selectedCountryId = useAppSelector(selectSelectedCountryId);
  const examCountryId = countryId ?? selectedCountryId;
  const { data: allowOnlinePaymentData } = useGetAllowOnlinePaymentQuery({ countryId: examCountryId });
  const { data: currentDiscountData } = useGetCurrentDiscountQuery({ countryId: examCountryId });

  const onlinePaymentDiscountAvailable = useMemo(() => {
    return allowOnlinePaymentData && currentDiscountData && currentDiscountData.Discount > 0;
  }, [allowOnlinePaymentData, currentDiscountData]);

  const discountNumber = useMemo(() => {
    if (!currentDiscountData) {
      return 0;
    }   
    return currentDiscountData.Discount;
    }, [currentDiscountData]);

  const discountPercentage = useMemo(() => {
    if (!currentDiscountData) {
      return undefined;
    }
    return `${currentDiscountData.DiscountPercentage}%`;
  }, [currentDiscountData]);

  return {
    onlinePaymentDiscountAvailable,
    discountNumber,
    discountPercentage
  };
};